import {
  ChangePasswordAction,
  ChangePasswordPayload,
  CreateUserAction,
  CreateUserPayload,
  DeleteUserAction,
  DeleteUserPayload,
  EditUserAction,
  EditUserPayload,
  FetchListUserActions,
  SelectRecordAction,
  SelectRecordPayload,
  UpdateListRolesAction,
  UpdateListRolesPayload,
  UpdateStateChangePwAction,
  UpdateStateForgotPwAction,
  UpdateStateListUserAction,
  UpdateStateListUserPayload,
  UpdateStateUserAction,
  UpdateStateUserPayload,
} from 'types/actions/userManage';

import { userManageConstant } from '../actionTypes';

export const fetchListUser = (): FetchListUserActions => ({
  type: userManageConstant.FETCH_LIST_USER,
});

export const updateStateListUser = (
  payload: UpdateStateListUserPayload
): UpdateStateListUserAction => ({
  type: userManageConstant.UPDATE_LIST_USER,
  payload,
});

export const updateStateUser = (
  payload: UpdateStateUserPayload,
  id: string
): UpdateStateUserAction => ({
  type: userManageConstant.UPDATE_USER,
  id,
  payload,
});

export const selectRecord = (text: string, record: SelectRecordPayload): SelectRecordAction => ({
  type: userManageConstant.SELECT_RECORD,
  record,
});

export const createUser = (payload: CreateUserPayload): CreateUserAction => ({
  type: userManageConstant.CREATE_USER,
  payload,
});

export const deleteUser = (record: DeleteUserPayload): DeleteUserAction => ({
  type: userManageConstant.DELETE_USER,
  record,
});

export const updateListRoles = (payload: UpdateListRolesPayload): UpdateListRolesAction => ({
  type: userManageConstant.UPDATE_LIST_ROLES,
  payload,
});

export const changePassword = (payload: ChangePasswordPayload): ChangePasswordAction => ({
  type: userManageConstant.CHANGE_PW,
  payload,
});

export const updateStateChangePw = (): UpdateStateChangePwAction => ({
  type: userManageConstant.UPDATE_STATE_CHANGE_PW,
});

export const updateStateForgotPw = (): UpdateStateForgotPwAction => ({
  type: userManageConstant.UPDATE_STATE_FORGOT_PW,
});

export const editUser = (payload: EditUserPayload): EditUserAction => ({
  type: userManageConstant.EDIT_USER,
  payload,
});
